var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button__container button__circle--purple",class:{button__circle : _vm.haveBg,
button__bigger : _vm.bigger},on:{"click":function($event){return _vm.changeSong(-1)}}},[_c('img',{attrs:{"src":_vm.prevSongIcon,"alt":"Previous Song Icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }